import { NgModule } from '@angular/core';

import { EmptyListComponent } from './empty-list.component';

@NgModule({
    imports: [],
    exports: [EmptyListComponent],
    declarations: [EmptyListComponent],
    providers: [],
})
export class EmptyListModule { }
